/*
 * @Descripttion:
 * @Author: Xinner
 * @Date: 2021-01-26 09:28:03
 * @LastEditors: Xinner
 * @LastEditTime: 2021-01-26 12:06:29
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store';
// import "./registerServiceWorker";
import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.less';
import '@/assets/default.less';

import './utils/filter'; // global filter

import Viser from 'viser-vue';
Vue.use(Viser);

import VCharts from 'v-charts';
Vue.use(VCharts);

import HighCharts from 'highcharts-vue';
Vue.use(HighCharts);


// 全局自定义组件
import {Ch2ComponsePlugin} from '@/components';
Vue.use(Ch2ComponsePlugin);

// $openDialog
import openDialogInstall from '@/utils/PromiseDialog';
Vue.use(openDialogInstall);
// init session
import userModule from '@/store/modules/user';

userModule.InitToken();

// router filter
import '@/router/routerPermission';
Vue.config.productionTip = false;
Vue.use(Antd);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
